import { useMemo } from 'react';
import { useGetSiteRiskInsightsAvailableDatesQuery } from 'src/app/site-nature-risk/state/api/siteNatureRiskEngineSlice';
import { groupDatesIntoQuarters, type TimePeriodOption } from 'src/shared/utils/timePeriodHelpers';

const useSiteAvailableTimePeriods = (
    organisationBusinessCentralId: string,
    siteId: string | undefined
): { timePeriods: TimePeriodOption[] } => {
    const { data } = useGetSiteRiskInsightsAvailableDatesQuery(
        { organisationBusinessCentralId, siteId: siteId ?? '' },
        { skip: !organisationBusinessCentralId || !siteId }
    );

    const timePeriods = useMemo(() => groupDatesIntoQuarters(data?.site?.riskInsightsAvailableDates ?? []), [data]);

    return { timePeriods };
};

export default useSiteAvailableTimePeriods;
